import { t } from "components/CentralDataMangement/translation/Translation";
import type { MouseEventHandler } from "react";
import React from "react";
import Reset from "static/images/Reset";
import Button from "./Button";

interface props {
  handleResetClick?: MouseEventHandler<HTMLButtonElement>;
}
const ResetBtn: React.FC<props> = ({ handleResetClick }) => {
  return (
    <Button
      title=""
      type="reset"
      handleClick={handleResetClick}
      className="delete-btn shadow-none"
      style={{ minWidth: "3vw", marginRight: "0.5vw" }}
    >
      <span title={t("Reset")}>
        <Reset />
      </span>
    </Button>
  );
};

export default ResetBtn;
